import React, { forwardRef, Ref } from "react";
import { List, WindowScroller } from 'react-virtualized';
import 'react-virtualized/styles.css'; // only needs to be imported once


interface IWindowScroller {
  rowCount: number;
  rowHeight: number;
  rowRenderer: (...args: any[]) => JSX.Element;
  rowWidth: number;
}

const CustomWindowScroller = forwardRef((props: IWindowScroller, ref: Ref<HTMLDivElement>) => {
  const {
    rowCount,
    rowHeight,
    rowRenderer,
    rowWidth,
  } = props;

  return (<WindowScroller scrollElement={ref?.current ? ref.current : window}>
    {({ height, isScrolling, registerChild, scrollTop, onChildScroll }: {
      height: number;
      width: number;
      isScrolling: boolean;
      scrollTop: number;
      scrollLeft: number;
      onChildScroll: (params: { scrollTop: number }) => void;
      registerChild: (element?: React.ReactNode) => void;
    }) => (
      <div ref={registerChild} >
        <List
          autoHeight
          isScrolling={isScrolling}
          rowCount={rowCount}
          rowHeight={rowHeight}
          height={height}
          onScroll={onChildScroll}
          rowRenderer={rowRenderer}
          scrollTop={scrollTop}
          overscanIndicesGetter={(props) => {
            const { overscanCellsCount, startIndex, stopIndex, cellCount } = props;
            return {
              overscanStartIndex: startIndex <= props.overscanCellsCount ? 0 : startIndex - overscanCellsCount,
              overscanStopIndex: stopIndex + overscanCellsCount < cellCount ? stopIndex + overscanCellsCount : stopIndex
            }
          }}
          overscanRowCount={4}
          width={rowWidth}
        />
      </div>
    )}
  </WindowScroller>);
});

export default CustomWindowScroller;